import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface HomeSectionCfg { enabled: boolean; order: number }
export type HomeSectionsMap = Record<string, HomeSectionCfg> | null;

/**
 * Lit la configuration des sections de la page d'accueil (visibilité + ordre)
 * depuis la table `homepage_sections`, administrable via l'Operations Hub.
 * Retourne `null` tant que les données ne sont pas chargées OU en cas d'erreur,
 * ce qui fait retomber la home sur son ordre par défaut (zéro régression).
 */
export function useHomeSections(): HomeSectionsMap {
  const [map, setMap] = useState<HomeSectionsMap>(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data, error } = await supabase
          .from('homepage_sections')
          .select('section_key, enabled, display_order');
        if (!active || error || !data) return;
        const m: Record<string, HomeSectionCfg> = {};
        for (const r of data as any[]) {
          m[r.section_key] = { enabled: r.enabled !== false, order: r.display_order ?? 999 };
        }
        setMap(m);
      } catch {
        /* fallback silencieux : on conserve l'ordre par défaut */
      }
    })();
    return () => { active = false; };
  }, []);

  return map;
}

export default useHomeSections;
